import React from 'react';

import { Row, Col, Button } from 'reactstrap';

let InfoItem = (props) => {
    return (
        <React.Fragment>
            <Row>
                <Col className="text-center" xs="3" md="3" lg="3" xl="3">
                    <Button className="btn-round btn-icon" size="md" outline>
                        {props.rol.iconComponent}
                    </Button>
                </Col>

                <Col xs="9" md="9" lg="9" xl="9">
                    <div style={{ marginTop: 10, textTransform: "uppercase" }}>
                        {props.rol.name}
                        <br />
                        <span className="text-muted" style={{ textTransform: "none" }}>
                            <small>{props.rol.description}</small>
                        </span>
                    </div>
                </Col>
            </Row>
            <hr></hr>
        </React.Fragment>
    );
}

export default InfoItem;